<template>
    <div class="header-msg f-18">
        <div class="header-style d-flex item-center">
            <div class="title-before"></div>
            <div class="fw-800">{{ msg }}</div>
            <div class="right-icon d-flex item-center">
                <div v-if="rightSelect && rightSelect.type === 'radio'" class="right-select">
                    <el-radio-group v-model="rightSelect.value" size="small">
                        <el-radio-button v-for="item in rightSelect.list" :label="item.label" :value="item.value" :key="item.value"/>
                    </el-radio-group>
                </div>
                <div>
                    <!-- <i class="el-icon-more"></i> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: ['msg', 'rightSelect'],
    data() {
        return {
        }
    }
}
</script>

<style lang="less" scoped>
.header-msg{
    .header-style{
        height: 50px;
        width: 96%;
        color: rgb(255, 255, 255, 1);
        background: rgba(36, 42, 60, 1);
        .title-before{
            width: 8px;
            height: 40px;
            background: rgba(238, 144, 59, 1);
            margin-left: 2px;
            margin-right: 10px;
        }
        .right-select{
            margin-right: 12px;
        }
        .right-icon{
            margin-left: auto;
        }
    }
}
</style>
